export default __webpack_public_path__ + "static/media/blog-three.6a969adb.png";